import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconTvComponent } from "./med-icon-tv.component";

@NgModule({
  declarations: [
    MedIconTvComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconTvComponent,
  ],
})
export class MedIconTvModule { }
